// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"spinner_spinnerWrapper__2q4ow","spinnerBackground":"spinner_spinnerBackground__DHmrr","spinner":"spinner_spinner__1Wlkw","load3":"spinner_load3__2DECe"};